



















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import Icon from '../../../components/Icon/Icon.vue'
import { VueComponent } from "../../../shared/types/VueComponent";
import { MenuDropdown, MenuItem } from "../NewConfig";

@Component({
  components: {
    Icon,
  },
})
export default class CustomDropdownItem extends Vue {
  @Prop() item !: MenuDropdown

  isPopupOpen = false

  popupComponent: VueComponent | null = null

  dropDownItemClickHandler(menuItem:MenuItem): void {
    if (menuItem.type === 'Component') {
      this.popupComponent = menuItem.component

      this.isPopupOpen = true
    }
  }
}
